import { BaseEntity } from '../base/BaseEntity'
import { Field, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import type { BlogStatusEnum } from './BlogStatusEnum'
import type { BlogContentType } from './BlogContentType'

@ObjectType()
@InputType('BlogInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class Blog extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  title?: string

  @Field(() => String)
  @Prop({ type: String })
  cover?: string

  @Field(() => String)
  @Prop({ type: String })
  contentUrl?: string

  @Field(() => String)
  @Prop({ type: String })
  contentHtml?: string

  @Field(() => String)
  @Prop({ type: String })
  content?: string

  @Field(() => String)
  @Prop({ type: String })
  description?: string

  @Field(() => String)
  @Prop({ type: String })
  declare status?: BlogStatusEnum

  @Field(() => String)
  @Prop({ type: String })
  contentType?: BlogContentType

  @Field(() => String)
  @Prop({ type: String })
  slug?: string

  @Field(() => String)
  @Prop({ type: String })
  filePath?: string
}
